import { defineMessages } from 'react-intl';

export const ThermalAdditionalFields = defineMessages({
  flowRateRequired: {
    id: 'app.common.flowRateRequired',
    defaultMessage: 'Zadejte průtok!',
  },
});

export const WaterAdditionalFields = defineMessages({
  twinMeter: {
    id: 'app.common.twinMeter',
    defaultMessage: 'Twin Meter',
  },
  yes: {
    id: 'app.common.yes',
    defaultMessage: 'Ano',
  },
  no: {
    id: 'app.common.no',
    defaultMessage: 'Ne',
  },
  selectValid: {
    id: 'app.common.selectValid',
    defaultMessage: 'Vyber platné',
  },
  flowRateRequired: {
    id: 'app.common.flowRateRequired',
    defaultMessage: 'Zadejte průtok!',
  },
});

export const SerialNumberTooltip = defineMessages({
  electricity: {
    id: 'app.SerialNumberTooltip.electricity',
    defaultMessage: 'Může být značeno například Nr., NO, S/N, N°, SČ...',
  },
  water: {
    id: 'app.SerialNumberTooltip.water',
    defaultMessage:
      'Většinou největší číslo na vodoměru (6-8 číslic, může být ale i více) POZOR - snadno zaměnitelné s číslem modulu',
  },
  gas: {
    id: 'app.SerialNumberTooltip.gas',
    defaultMessage:
      'Většinou největší číslo na plynoměru (značeno např. Nr., S/N, může být uvedeno zboku plynoměru vedle čárového kódu)',
  },
});

export const DetailStepContent = defineMessages({
  detailPhotosHelp: {
    id: 'app.common.detailPhotosHelp',
    defaultMessage: 'Měřidlo vyfoť zblízka. Fotky by měly být dostatečně ostré.',
  },
  detailPhotosLabel: {
    id: 'app.common.detailPhotosLabel',
    defaultMessage: 'Fotky detail',
  },
  detailPhotosRequired: {
    id: 'app.common.detailPhotosRequired',
    defaultMessage: 'Musíš nahrát alespoň jednu fotku detailu měřidla!',
  },
  detailPhotosTooltip: {
    id: 'app.common.detailPhotosTooltip',
    defaultMessage:
      'Vyfoť důkladně detaily měřidla případně prostor kam by mělo být instalováno pokud se jedná o nový podružné měřidlo.',
  },
  serialNumber: {
    id: 'app.common.serialNumber',
    defaultMessage: 'Sériové číslo',
  },
  lorawanRssi: {
    id: 'app.common.lorawanRssi',
    defaultMessage: 'Signál LoRaWAN',
  },
  lorawanRssiRequired: {
    id: 'app.common.lorawanRssiRequired',
    defaultMessage: 'Zadej číslo bez mínuska!',
  },
  lorawanRssiTooltip: {
    id: 'app.common.lorawanRssiTooltip',
    defaultMessage: 'Uveď pouze číslo zobrazené na zkoušečce bez mínusu',
  },
  nbiotRssi: {
    id: 'app.common.nbiotRssi',
    defaultMessage: 'Signál NB-IoT',
  },
  nbiotRssiRequired: {
    id: 'app.common.nbiotRssiRequired',
    defaultMessage: 'Zadej číslo bez mínuska!',
  },
  nbiotRssiTooltip: {
    id: 'app.common.nbiotRssiTooltip',
    defaultMessage: 'Uveď pouze číslo zobrazené na zkoušečce bez mínusu',
  },
  accessibility: {
    id: 'app.common.accessibility',
    defaultMessage: 'Přístupnost',
  },
  accessibilityRequired: {
    id: 'app.common.accessibilityRequired',
    defaultMessage: 'Pokud je měřidlo dobře dostupné, vyber možnost "Dobrá"!',
  },
  selectValid: {
    id: 'app.common.selectValid',
    defaultMessage: 'Vyber platné',
  },
  note: {
    id: 'app.ServiceInspection.note',
    defaultMessage: 'Poznámka',
  },
  notePlaceholder: {
    id: 'app.ServiceInspection.notePlaceholder',
    defaultMessage: 'Je třeba speciálního vybavení! Nachází se ve stísněné šachtě!',
  },
});

export const DetailStepFooter = defineMessages({
  back: {
    id: 'app.common.back',
    defaultMessage: 'Zpět',
  },
  next: {
    id: 'app.common.next',
    defaultMessage: 'Další',
  },
});
